/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components'

interface paramStyleProps {
  width?: any
  heigth?: any
}

const ModalManagerWithdrawContainer = styled.div<paramStyleProps>`
  width: ${({ width }) => width + 'px'};
  height: ${({ heigth }) => heigth + 'px'};
  position: relative;
  background-color: #EF902F;
  -webkit-clip-path: polygon(0% 0%, 0 90%, 100% 300%, 100% 100%, 100% 0%);
  clip-path: polygon(0% 0%, 0 90%, 100% 300%, 100% 100%, 100% 0%);

  &:before {
    content: '';
    position: absolute;
    width: ${({ width }) => (width - 2) + 'px'};
    height: ${({ heigth }) => (heigth - 2) + 'px'};
    top: 1px;
    left: 1px;
    background-color: #191D2C;
    display: block;
    -webkit-clip-path: polygon(0% 0%, 0 90%, 100% 300%, 100% 100%, 100% 0%);
    clip-path: polygon(0% 0%, 0 90%, 100% 300%, 100% 100%, 100% 0%);
  }

  .header {
    margin-bottom: 16px;
    p {
      text-align: center;
      padding-top: 20px;
      position: relative;

      &:after {
        content: '';
        width: 80%;
        height: 1px;
        background: #5e6684;
        bottom: -4px;
        left: 10%;
        position: absolute;
      }

      .title {
        display: inline-block;
        width: fit-content;
        color: #4ef076;
        font-size: 24px;
        line-height: 24px;
        text-transform: uppercase;
      }
    }
  }

  .close-btn {
    top: 10px;
    right: 10px;
    background-color: ${({ theme }) => theme.color.transparent};
    border: none;
    z-index: 1;
  }

  .content-box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    p {
      color: #fff;
      font-size: 20px;
      text-align: center;
      padding-top: 20px;
    }
  }

  .button-box {
    display: flex;
    bottom: 30px;
    position: absolute;
    justify-content: center;
    width: 100%;
    gap: 170px;
  }

  .img_select {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 5px;
    margin-top: -5px;

    img {
      width: 100%;
      height: 100%;
      margin-top: -5px;
    }
  }
`

export { ModalManagerWithdrawContainer }
